<div class="cu-dialog">
  <div class="cu-header">
    <div class="cu-title-wrap"><div class="cu-title-icon"><mat-icon>cloud</mat-icon></div><div><h2 class="cu-title">Cloud attachment</h2><div class="cu-subtitle">Attach a shareable link to this event</div></div></div>
    <button mat-icon-button mat-dialog-close class="cu-close" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <form id="url" class="cu-body" (ngSubmit)="submit()">
    <label class="cu-label" for="cloud-url">Cloud storage URL</label>
    <div class="cu-input-wrap"><mat-icon>link</mat-icon><input id="cloud-url" type="url" name="url" required [(ngModel)]="url" placeholder="https://drive.google.com/..."></div>
    <p>Use a link that your teammates have permission to open.</p>
  </form>
  <div class="cu-footer"><button mat-button mat-dialog-close class="cu-btn-ghost">Cancel</button><button type="submit" form="url" class="cu-btn-primary"><span>Attach link</span><mat-icon>check</mat-icon></button></div>
</div>
